




































































import { Component, Vue, Prop } from 'vue-property-decorator'
import * as utils from '@ivy/fts/utils'
@Component
export default class VipForNewComer extends Vue {
  @Prop({ default: false }) isHasRequire: boolean // 是否已经领取
  @Prop({ default: false }) isAlreadyget: boolean // 是否是领取后又打开的界面
  @Prop({ default: false }) isOldNotAvailable: boolean // 老用户是否可领
  phoneNumber: string
  smsCode: any = null
  geting: boolean = false
  countdownTimer: any = '重新获取 60s'
  get getCodeText() {
    if (!this.geting) return '获取验证码'
    return this.countdownTimer
  }

  async mounted() {
    window.addEventListener('scroll', this.debounce(this.scrollPage, 100))
  }

  scrollPage() {
    try {
      let dom: any = this.$refs.experienceCard
      let rect = dom.getBoundingClientRect()
      if (rect.top < -rect.height) {
        this.$emit('leaveView', true)
        return
      }
      this.$emit('leaveView', false)
    } catch {}
  }

  debounce(fn, wait) {
    let timeout = null
    return () => {
      if (timeout !== null) clearTimeout(timeout)
      timeout = setTimeout(fn, wait)
    }
  }

  async sendSmsCode() {
    if (!this.phoneNumber) {
      this.$Toast('请输入手机号')
      return
    }
    if (!/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
      this.$Toast('手机号格式不正确')
      return
    }
    if (this.geting) return
    this.geting = true
    this.$emit('sendSmsCode', this.phoneNumber)
    for (let count = 60; count > 0; count--) {
      this.countdownTimer = `重新获取 ${count}s`
      await utils.sleep(1000)
    }
    this.geting = false
  }

  async freeGetHandelr() {
    this.$emit('addStatistics', 'click_freeGet')
    if (!this.phoneNumber || !this.smsCode) {
      this.$Toast('请输入必要信息')
      return
    }
    this.$emit('clickHandler', {
      type: 'freeGet',
      phoneNumber: this.phoneNumber,
      smsCode: this.smsCode,
    })
  }

  openApp() {
    this.$emit('clickHandler', {
      type: 'openApp',
    })
  }

  destroyed() {
    window.removeEventListener('scroll', () => {})
  }
}
